/**
 * Ereignisse der Kampagne an Umami melden.
 *
 * Das Konzept verlangt, dass sich der Radio-Effekt getrennt messen lässt:
 * Anrufe, gestartete und abgeschickte Betreuungs-Checks, angehörte Beiträge,
 * aufgeklappte Transkripte.
 * Ein Seitenaufruf allein sagt darüber nichts — wer die Nummer antippt und
 * anruft, hinterlässt sonst keine Spur.
 *
 * Die Funktion `track` selbst liegt in `website/tracking.ts`, gemeinsam mit den
 * Ereignissen der Kundenwebsite — beide Auftritte melden an dieselbe Stelle.
 */
export { track } from '../tracking';

/** Ereignisnamen an einer Stelle, damit die Auswertung nicht an Tippfehlern scheitert. */
export const M38_EVENTS = {
  telefon: 'm38-telefon',
  checkStart: 'm38-check-start',
  checkGesendet: 'm38-check-gesendet',
  audio: 'm38-audio',
  transkript: 'm38-transkript',
  transkriptSprung: 'm38-transkript-sprung',
  cta: 'm38-cta',
} as const;
